import { createContext, useContext, useState, useEffect } from 'react';

const LanguageContext = createContext();

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState(() => {
    return localStorage.getItem('kettera_lang') || 'es';
  });

  useEffect(() => {
    localStorage.setItem('kettera_lang', lang);
  }, [lang]);

  const toggleLanguage = () => {
    setLang(prev => prev === 'es' ? 'en' : 'es');
  };

  return (
    <LanguageContext.Provider value={{ lang, toggleLanguage }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLanguage() {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within LanguageProvider');
  }
  return context;
}

export function T({ es, en, components = {} }) {
  const { lang } = useLanguage();
  const text = lang === 'es' ? es : en;

  if (!components || Object.keys(components).length === 0) {
    return <>{text}</>;
  }

  const parts = [];
  let currentIndex = 0;
  
  const tagRegex = /<(\w+)>(.*?)<\/\1>/g;
  let match;

  while ((match = tagRegex.exec(text)) !== null) {
    if (match.index > currentIndex) {
      parts.push(text.substring(currentIndex, match.index));
    }

    // Procesa el tag
    const tagName = match[1]; 
    const tagContent = match[2];
    const Component = components[tagName];

    if (Component) {
      parts.push(
        <Component key={match.index}>{tagContent}</Component>
      );
    } else {
      parts.push(tagContent);
    }

    currentIndex = tagRegex.lastIndex;
  }

  if (currentIndex < text.length) {
    parts.push(text.substring(currentIndex));
  }

  return <>{parts}</>;
}

export function useTranslate() {
  const { lang } = useLanguage();
  
  return (es, en) => {
    return lang === 'es' ? es : en;
  };
}
